import { render, staticRenderFns } from "./TopicFaqs.vue?vue&type=template&id=3018b432&scoped=true&"
import script from "./TopicFaqs.vue?vue&type=script&lang=js&"
export * from "./TopicFaqs.vue?vue&type=script&lang=js&"
import style0 from "./TopicFaqs.vue?vue&type=style&index=0&id=3018b432&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3018b432",
  null
  
)

export default component.exports